import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataShimmer, Helpfull } from '../common';
import Toast from '../common/Toast/Toast';
import WithCsportalAuth from '../../hooks/WithCsportalAuth';
import FaqWrapper from '../common/FaqWrapper';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import { useAppState } from '../../contexts/appState';
import { getPaymentsInfo, handleImpressionsTrack } from '../../api';
import AllPaymentsHistory from './PaymentsDetails/AllPaymentsHistory';
import PaymentsFaq from './PaymentsFaq';
import { clickTracker, getCookie, getProjectId, getSourceValue } from '../../lib/common';
import NoDataView from '../../pages/NoDataView';
import { useAuth } from '../../contexts/auth';

function Payments() {
  const [selectedBusinessData, , refetchSelectedBusiness] = useLocalStorage('selectedBusiness', {});
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const [userDetails] = useSessionStorage('userDetails', '');
  const [paymentResp, setPaymentResp] = useState({});
  const [loading, setLoading] = useState(true);
  const source = getSourceValue();
  const navigate = useNavigate();
  const [appState] = useAppState();
  const [authState] = useAuth();

  const projectId = getProjectId();
  const [toastMsg, setToastMsg] = useState({
    message: '',
    status: '',
  });
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  useEffect(() => {
    const handleGetPaymentsInfo = async () => {
      try {
        setLoading(true);
        let paramsData = {};
        if (projectId === 'csportal') {
          if (appState?.csportalData?.docId && !selectedBusinessData.parentid) {
            refetchSelectedBusiness();
            return;
          }
          paramsData = {
            key: 'paymentsNew',
            docId: selectedBusinessData?.docid || '',
            parentId: selectedBusinessData?.parentid || '',
            mobile: userDetails?.mobile || '',
            compName: selectedBusinessData?.compname ? encodeURIComponent(selectedBusinessData?.compname) : '',
            area: selectedBusinessData?.areaname ? encodeURIComponent(selectedBusinessData?.areaname) : '',
            city: selectedBusinessData?.data_city ? encodeURIComponent(selectedBusinessData?.data_city) : '',
            source,
            sid: getCookie('sid') || '',
            shortUrl: selectedBusinessData?.shorturl || '',
            backUrl: encodeURI(window.location.href),
            projectId,
          };
        } else {
          paramsData = {
            key: 'paymentsNew',
            docId: selectedBusinessGenio?.docId || '',
            parentId: selectedBusinessGenio?.parentId || '',
            mobile: profile?.mobile || '',
            compName: selectedBusinessGenio?.companyName ? encodeURIComponent(selectedBusinessGenio?.companyName) : '',
            area: selectedBusinessGenio?.location ? encodeURIComponent(selectedBusinessGenio?.location) : '',
            city: selectedBusinessGenio?.city ? encodeURIComponent(selectedBusinessGenio?.city) : '',
            source,
            sid: getCookie('sid') || '',
            shortUrl: selectedBusinessGenio?.shorturl || '',
            backUrl: encodeURI(window.location.href),
            projectId,
          };
        }
        const res = await getPaymentsInfo(paramsData);
        if (res) {
          setPaymentResp(res);
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    };

    handleGetPaymentsInfo();
  }, [selectedBusinessData, appState?.csportalData?.docId]);

  const handleViewMorePayments = async () => {
    await clickTracker(
      'payments_details_viewhistory',
      projectId === 'csportal' ? 'payments_details' : 'geniocs_payments_faq',
    );
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_viewmorepayments`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_payments`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    navigate(projectId === 'csportal' ? '/csportal/payment_history' : '/genio/payment_history', {
      state: { paymentsHistoryData: paymentResp?.paymentsdetails?.finalPaymentsArr || [] },
    });
  };

  return (
    <>
      {loading ? (
        <DataShimmer loading={loading} id="ecsfaq" />
      ) : (
        <>
          {paymentResp?.paymentsdetails && paymentResp?.faqdetails?.length > 0 ? (
            <>
              <AllPaymentsHistory
                data={
                  (paymentResp?.paymentsdetails?.finalPaymentsArr && [
                    paymentResp?.paymentsdetails?.finalPaymentsArr?.[0],
                  ]) ||
                  []
                }
                paymentHistoryUrl={paymentResp?.paymentHistoryUrl}
                pageId="home"
                handleViewMorePayments={handleViewMorePayments}
                showMorePayments={paymentResp?.paymentsdetails?.finalPaymentsArr?.length > 1}
              />
              <PaymentsFaq
                paymentsFaq={paymentResp || {}}
                projectId={projectId}
                selectedBusinessData={selectedBusinessData}
                paymentHistoryUrl={paymentResp?.paymentHistoryUrl}
              />
              <Helpfull redirectkey="payments" projectId={projectId} />
            </>
          ) : (
            <NoDataView pageName="Payments & Invoices" />
          )}
        </>
      )}
      {projectId === 'genio' && toastMsg?.message && <Toast toastMsg={toastMsg} setToastMsg={setToastMsg} />}
    </>
  );
}

export default WithCsportalAuth(FaqWrapper(Payments), 'paid');
